/**
 * Presentation variants for `CartBundleItemPrice`.
 *
 * The main cart and the cart flyout show the same numbers with different treatments, so the two
 * surfaces share one component and select a variant rather than duplicating the price logic. See the
 * SUN-292 implementation guide, "Design node extraction".
 */
export enum CartBundleItemPriceVariant {
  /** Main cart: pre- and post-discount stacked, post-discount in magenta. The long-standing look. */
  Stacked = 'stacked',
  /**
   * Cart flyout: the two prices inline with a gap, post-discount bold black.
   * Figma `15980:29666` (desktop) / `15927:54471` (mobile).
   */
  Inline = 'inline'
}
